import { ShowOrderService } from 'application/services/show-order'
import { api } from 'infra/adapters/http-client-adapter'

export const handleShowOrder = new ShowOrderService(api)
